
export const truncatedTwoDecimalNumber = (num: number): number => Math.trunc(num * 100) / 100;
